import { IPageContent } from "api/interfaces/static-content.type";
import classnames from "classnames";
import CategoryBannerRegular from "component/category/banner/CategoryBannerRegular";
import BannerDescription from "component/category/category-vehicle-banner-section/BannerDescription";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { checkIfBannerV2IsPresent } from "component/landing-page/checkIfBannerV2IsPresent";
import { RootState } from "interfaces/generics.type";
import HomeGarage from "modules/home/garage/HomeGarage";
import { StyledOverlayBox } from "modules/home/garage/StyledHomeGarageRegular.style";
import Breadcrumbs from "modules/product/header/Breadcrumbs";
import { DEFAULT_CATEGORY_BANNER } from "modules/site-structure/common/make-model-year-utils";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getFragmentParams } from "util/url/getFragmentParams";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import styles from "./newPageHeader.module.scss";

interface IProps {
  staticContent: IPageContent;
}

function NewPageHeader(props: IProps) {
  const {
    fitmentOptionsDetails, fitmentOptionsPrompt, staticContent,
    bannerData, hideDescription = false, showBreadCrumb,
    bannerProps, pageDisplayableTitle, breadCrumbsV2,
    breadCrumbProps, fullWidthBanner,
  } = props;

  const router = useRouter();
  const { query = {} } = router;

  const { urlInformation } = useSelector((state: RootState) => state.utils);
  const { selectedVehicle } = useSelector((state: RootState) => state.garage);

  const { year: fragmentYear, make: fragmentMake, model: fragmentModel } = getFragmentParams();

  const defaultYear = urlInformation.year || query.year || fragmentYear;
  const defaultMake = urlInformation.make || query.make || fragmentMake;
  const defaultModel = urlInformation.model || query.model || fragmentModel;

  const { bannerDescription, bannerImagesV2 } = staticContent;

  let maxHeightClass = "";
  if (bannerDescription && checkIfBannerV2IsPresent(bannerImagesV2)) {
    maxHeightClass = styles.max_height_for_new_banner;
  } else if (bannerDescription) {
    maxHeightClass = styles.max_height_for_old_banner;
  }

  return (
    <>
      <HideIf show={showBreadCrumb}>
        <Breadcrumbs
          {...{
            breadCrumbsV2, staticContent, ...breadCrumbProps,
          }}
        />
      </HideIf>

      <div className={styles.banner_container}>
        <div
          className={classnames(styles.vehicle_selector, {
            [styles.vehicle_selected]: validateVehicle(selectedVehicle),
          })}
          data-clarity-unmask="true"
        >
          <HideIf show={pageDisplayableTitle}>
            <PAText component="h1" color="black" bold fontSize={FONT_SIZE[5]} className="m-b-15 m-t-0">
              {pageDisplayableTitle}
            </PAText>
          </HideIf>

          <StyledOverlayBox isCompactGarage>
            <HomeGarage
              isCompactGarage
              defaultMake={defaultMake}
              defaultModel={defaultModel}
              defaultYear={defaultYear}
              fitmentOptionsDetails={fitmentOptionsDetails}
              fitmentOptionsPrompt={fitmentOptionsPrompt}
              bannerData={bannerData}
            />
          </StyledOverlayBox>
        </div>
        <div className={styles.category_banner}>
          <div className={maxHeightClass}>
            <CategoryBannerRegular
              {...{
                staticContent,
                bannerData: {
                  ...bannerData,
                  fallbackImage: DEFAULT_CATEGORY_BANNER,
                },
                showBreadCrumb,
                bannerProps,
                responsiveBannerMedia: staticContent.responsiveBannerMedia,
              }}
              maintainAspectRatio={Boolean(bannerDescription)}
              fullWidthBanner={fullWidthBanner}
            />
          </div>
          <HideIf show={!hideDescription}>
            <BannerDescription description={bannerDescription} />
          </HideIf>
        </div>
      </div>
    </>
  );
}

export default NewPageHeader;
